/**
 * @fileoverview Shared Organisation schema used by both frontend and backend.
 */

import { z } from 'zod';
import { commonValidators, createCrudSchemas, createDisplayableEntitySchema, getSchemaFields } from './base.js';
import { ID_PATTERNS } from './types.js';

export const OrganisationSchema = createDisplayableEntitySchema(
  ID_PATTERNS.ORGANISATION,
  'ID must be in or-prefixed nanoid7 format',
  {
    accountTracking: 'standard',
    additionalFields: {
      website: commonValidators.optionalUrl('Website'),
      email: commonValidators.email(),
      phone: commonValidators.phone(),
      logo: commonValidators.optionalUrl('Logo'),
    },
  }
);

const { CreateSchema, UpdateSchema } = createCrudSchemas(OrganisationSchema);

export const OrganisationCreateSchema = CreateSchema;
export const OrganisationUpdateSchema = UpdateSchema;

export type Organisation = z.infer<typeof OrganisationSchema>;
export type OrganisationCreate = z.infer<typeof OrganisationCreateSchema>;
export type OrganisationUpdate = z.infer<typeof OrganisationUpdateSchema>;

export const ORGANISATION_FIELDS = getSchemaFields(OrganisationSchema);
